import type {Schedule} from '../../types/domain'
import type {TimerSnapshot} from './timerSnapshot'

export function reconcileLiveTimer(schedule: Schedule, snapshot: TimerSnapshot, serverNowMs: number): TimerSnapshot {
  let current = snapshot
  while (current.clock.kind === 'running' && current.clock.deadlineMs <= serverNowMs) {
    const boundaryMs = current.clock.deadlineMs
    if (current.onBreak) {
      current = {...current, onBreak: false, breakIndex: current.breakIndex + 1, levelIndex: current.levelIndex + 1}
    } else if (schedule.breaks[current.breakIndex]?.afterLevelNumber === current.levelIndex + 1) {
      current = {...current, onBreak: true}
    } else {
      current = {...current, levelIndex: current.levelIndex + 1}
    }
    if (!current.onBreak && current.levelIndex >= schedule.blinds.length - 1) {
      return {...current, capturedAtMs: serverNowMs, clock: {kind: 'suddenDeath'}}
    }
    const durationMs = (current.onBreak ? schedule.breaks[current.breakIndex].length : schedule.levelLength) * 60000
    if (!Number.isFinite(durationMs) || durationMs <= 0) throw new Error('Invalid segment duration')
    current = {...current, capturedAtMs: serverNowMs, clock: {kind: 'running', deadlineMs: boundaryMs + durationMs}}
  }
  return current
}
